import React from 'react';
import styled, { css } from 'styled-components';
import { TaskOrientation, TaskProps } from '../../services/task';

interface Props {
    orientation: TaskOrientation,
    done: TaskProps['done'];
    onClick(): void;
}

export default function TaskStatus({ orientation, done, onClick }: Props) {

    function handleClick(e: React.MouseEvent) {
        e.stopPropagation();
        onClick();
    }

    return (
        <Wrapper orientation={orientation} className={`task-status-container ${done && 'done'}`} onClick={handleClick}>
            <div className="task-status-transform">
                <div className="task-status">
                    {/* <div className="task-status-icon"></div> */}
                </div>
            </div>
        </Wrapper>
    )
}

const Wrapper = styled.div<{ orientation: TaskOrientation }>`
    grid-area: status;
    display: flex;

    &.done {
        .task-status {
            background-color: #00796b;
        }

        .task-status-icon {
            background-color: ${props => props.theme.foregroundColor};
        }
    }

    .task-status {
        width: 40px;
        min-width: 40px;
        height: 40px;
        border-radius: 50%;

        border-width: 5px;
        border-style: solid;
        border-color: ${props => props.theme.backgroundColor};
        background-color: ${props => props.theme.foregroundColor};
        transition: background-color var(--ui-animation-duration), transform var(--ui-animation-duration);

        display:flex;
        align-items: center;
        justify-content: center;

        &:hover {
            background-color: #00796b;
            cursor: pointer;

            .task-status-icon {
                background-color: #fff;
                transform: scale(1.2);
            }
        }
    }

    .task-status-icon {
        width: 14px;
        height: 14px;
        /* margin: 15px; */
        background-color: ${props => props.theme.backgroundColor};;
        border-radius: 50%;
        transition: background-color var(--ui-animation-duration), transform var(--ui-animation-duration);   
    }

    ${({ orientation }) => orientations[orientation]}
`

const orientations = {
    [TaskOrientation.HORIZONTAL]: css`
        height: 30px;
        align-items: flex-end;
        justify-content: center;

        .task-status-transform {
            transform: translateY(calc(10px + 10px));
        }
    `,
    [TaskOrientation.VERTICAL]: css`
        align-items: center;
        justify-content: flex-start;
        
        .task-status-transform {
            transform: translateX(calc(-20px - 10px - 10px));
        }
    `,
}